module.exports = __webpack_public_path__ + "img/01.30e0d347.png";